export const CHECK_DOCUMENT_TEMPLATE_LAYOUT_TOOL =
  'check_document_template_layout';
